import {
  PersonalData,
  UpdateProfileActionTypes,
  UpdateProfileFailure,
  UpdateProfileFields,
  UpdateProfileInput,
  UpdateProfileRequest,
  UpdateProfileReset,
  UpdateProfileResetError,
  UpdateProfileSuccess,
} from './types';

export function updateProfile(input: UpdateProfileInput): UpdateProfileRequest {
  return {
    type: UpdateProfileActionTypes.UPDATE_PROFILE_REQUEST,
    input,
  };
}

export function updateProfileSuccess(): UpdateProfileSuccess {
  return {
    type: UpdateProfileActionTypes.UPDATE_PROFILE_SUCCESS,
  };
}

export function updateProfileError(error: Error): UpdateProfileFailure {
  return {
    type: UpdateProfileActionTypes.UPDATE_PROFILE_FAILURE,
    error,
  };
}

export function updateProfileResetError(): UpdateProfileResetError {
  return {
    type: UpdateProfileActionTypes.UPDATE_PROFILE_RESET_ERROR,
  };
}

export function updateProfileReset(): UpdateProfileReset {
  return {
    type: UpdateProfileActionTypes.UPDATE_PROFILE_RESET,
  };
}

export function updateProfileFields(fields: Partial<PersonalData>): UpdateProfileFields {
  return {
    type: UpdateProfileActionTypes.UPDATE_PROFILE_FIELDS,
    fields,
  };
}

